// extracted by mini-css-extract-plugin
export var contentBody = "_97-9";
export var headerImage = "_97-2";
export var imageButton = "_97-7";
export var imageButtonIcon = "_97-8";
export var imageHeader = "_97-4";
export var imageHeaderText = "_97-5";
export var imageOverlay = "_97-3";
export var imageTitle = "_97-6";
export var imageWrapper = "_97-1";
export var taskList = "_97-a";
export var widget = "_97-0";